module.exports = __webpack_public_path__ + "media/images/Rectangle-91bb52920dd0663b7911a11c4274b232.png";